import { Component, OnInit } from '@angular/core';
import { ApplicationService } from '../../../shared/services/application.service';
import { InitEndpoint } from '../../../shared/services/init-endpoint';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  header: InitEndpoint.Header;
  constructor(private applicationService: ApplicationService) {
    this.header = this.applicationService.initObject.header;
  }

  ngOnInit(): void {}
}
